__turbopack_context__.v({
  "card": "AiIndustrySolutions-module__V-g3oq__card",
  "cardBody": "AiIndustrySolutions-module__V-g3oq__cardBody",
  "cardDesc": "AiIndustrySolutions-module__V-g3oq__cardDesc",
  "cardTitle": "AiIndustrySolutions-module__V-g3oq__cardTitle",
  "header": "AiIndustrySolutions-module__V-g3oq__header",
  "heading": "AiIndustrySolutions-module__V-g3oq__heading",
  "iconBox": "AiIndustrySolutions-module__V-g3oq__iconBox",
  "section": "AiIndustrySolutions-module__V-g3oq__section",
  "subheading": "AiIndustrySolutions-module__V-g3oq__subheading",
});
